export default "__VITE_ASSET__B2tt1QAd__";